var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 15.2434C24.5812 15.2434 25.1875 15.8465 25.1875 16.5905C25.1875 17.3344 24.5812 17.9375 23.8333 17.9375H2.16667C1.41878 17.9375 0.8125 17.3344 0.8125 16.5905C0.8125 15.8465 1.41878 15.2434 2.16667 15.2434H23.8333ZM23.8333 8.05921C24.5812 8.05921 25.1875 8.6623 25.1875 9.40625C25.1875 10.1502 24.5812 10.7533 23.8333 10.7533H2.16667C1.41878 10.7533 0.8125 10.1502 0.8125 9.40625C0.8125 8.6623 1.41878 8.05921 2.16667 8.05921H23.8333ZM23.8333 0.875C24.5812 0.875 25.1875 1.47809 25.1875 2.22204C25.1875 2.96599 24.5812 3.56908 23.8333 3.56908H2.16667C1.41878 3.56908 0.8125 2.96599 0.8125 2.22204C0.8125 1.47809 1.41878 0.875 2.16667 0.875H23.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.c0083c6d3a0b879ced9e7d1dbd19dc7e.svg";
export { ForwardRef as ReactComponent };